import algoliasearch from "algoliasearch";

const algoliaConfig = {
  appId: "V16MHWRG95",
  apiKey: "11317c8df055c747d91af62b7e93966a",
};

const searchClient = algoliasearch(algoliaConfig.appId, algoliaConfig.apiKey);
export const predictions = searchClient.initIndex("predictions");
export const predictors = searchClient.initIndex("predictors");
export const surveys = searchClient.initIndex("surveys");
export const promises = searchClient.initIndex("promises");

export default searchClient;
